export const colorList = [
  'rgba(251, 191, 84, 1)',
  'rgba(238, 107, 59, 1)',
  'rgba(236, 15, 71, 1)',
  'rgba(160, 44, 93, 1)',
  'rgba(112, 4, 96, 1)',
  'rgba(2, 44, 122, 1)',
  'rgba(171, 217, 109, 1)',
  'rgba(21, 194, 134, 1)',
  'rgba(8, 115, 83, 1)',
  'rgba(4, 84, 89, 1)',
  'rgba(31, 64, 102, 1)',
  'rgba(26, 19, 51, 1)'
];
